import React, { Component } from "react"

import "./Navigation.scss"
import Navbar from "./Navbar"

class Navigation extends Component {



  render() {
    const { position } = this.props;

    return (
      <div className="navigation" style={{
        transform: `translateY(${position})`,
      }}>
        <Navbar />
      </div>
    )
  }
}

export default Navigation